import { render, staticRenderFns } from "./IcoMaterialContent.vue?vue&type=template&id=07086930"
import script from "./IcoMaterialContent.vue?vue&type=script&lang=js"
export * from "./IcoMaterialContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports